import {
    resolveArcRelationConstraintClassMap,
    resolveCircleRelationConstraintClassMap,
    resolveLineRelationConstraintClassMap,
    resolvePointRelationConstraintClassMap,
    resolveSlotRelationConstraintClassMap,
} from '../solver/constraint/GeometricRelationConstraints';
import {SketchRelationKind} from '../solver/constraint/relation-compatibility/SketchRelationKinds';

/** 支持集合缓存。 */
let supportedRelationKindSetCache: ReadonlySet<SketchRelationKind> | null = null;

/**
 * 解析草图持久化 v1 支持的关系类型集合（惰性构建）。
 *
 * 设计说明：
 * 1. 普通关系由各张“关系类型 → 约束类”映射派生，实体级对称关系走专用有序三元组构造；
 * 2. 与约束类映射一样采用首次调用惰性构建，规避 constraint 包既有循环依赖下的模块求值顺序问题；
 * 3. 序列化遇到集合外的关系必须显式失败，禁止静默丢弃，避免产出无法完整恢复的文档。
 *
 * @returns v1 支持的关系类型集合。
 */
export function resolveSupportedPersistentRelationKindSet(): ReadonlySet<SketchRelationKind> {
    if (!supportedRelationKindSetCache) {
        supportedRelationKindSetCache = new Set([
            ...Object.keys(resolveLineRelationConstraintClassMap()),
            ...Object.keys(resolvePointRelationConstraintClassMap()),
            ...Object.keys(resolveCircleRelationConstraintClassMap()),
            ...Object.keys(resolveArcRelationConstraintClassMap()),
            ...Object.keys(resolveSlotRelationConstraintClassMap()),
            SketchRelationKind.Symmetric,
        ] as SketchRelationKind[]);
    }
    return supportedRelationKindSetCache;
}
